export class AgreementDefaultOrder {
    direction?: string;
    name?: string;
}
